export default {
  // Game stages
  GAME_STAGE_DRAFT: 1,
  GAME_STAGE_COMMENCING: 2,
  GAME_STAGE_RUNNING: 3,
  GAME_STAGE_COMPLETE: 4,
  // Segment types
  SEGMENT_TYPE_POPULAR_BO_PEEP: 'popular_bo_peep',
  SEGMENT_TYPE_FIRST_IMPRESSION: 'first_impression',
  // Game prefix
  GAME_PREFIX: 'BAA-',
}



// WEBPACK FOOTER //
// ./src/lib/constants.js